import { createFileRoute } from '@tanstack/react-router';
import { ReviewAndAccept } from '@/features/terms/components/ReviewAndAccept';

export const Route = createFileRoute('/onboarding_/terms')({ component: ReviewAndAccept });
